import {
  FETCH_PROJECTS,
  SET_PROJECTS,
  SELECT_PROJECT,
  FETCH_PROJECTS_ERROR,
  SET_FLAGS,
  FETCH_SERVICEAREA,
  FETCH_ALL_SERVICEAREA,
  FETCH_ROLES,
  FETCH_UNITS_CONFIG,
  FETCH_PROJECT_UNITS_RAW,
  FETCH_PROJECT_UNITS_CONFIG,
  CLEAR_PROJECT_UNITS_CONFIG,
  FETCH_USERS,
  FETCH_ENTERPRISE_USERS,
  FETCH_PROJECT_ASSIGNMENTS,
  ASSIGN_ROLE_TO_USER,
  UPDATE_PROJECT,
  SET_AFTER_RELOAD,
  FETCH_WORKFLOW_STATUS,
  FETCH_SERVICEAREA_FEATURES,
  FETCH_ASSET_GROUPS,
  FETCH_ASSET_TYPES,
  FETCH_INTELLI_FIBER_ROLES,
  FETCH_INTELLI_FIBER_USER_ROLES,
  FETCH_PROJECT_USER_ROLES,
  FETCH_PERMISSIONS,
  FETCH_PHASES,
  FETCH_ROLE_PERMISSIONS,
} from '../../data/constants';

// eslint-disable-next-line
export default (state, action) => {
  switch (action.type) {
    case FETCH_PROJECTS:
      return {
        ...state,
        projects: action.payload,
        loading: false,
        loaded: true,
      };
    case FETCH_SERVICEAREA:
      let selectedProject = state.selectedProject
        ? { ...state.selectedProject, ServiceAreas: action.payload }
        : { ServiceAreas: action.payload };
      return {
        ...state,
        serviceAreas: action.payload,
        selectedProject,
        loading: false,
        loaded: true,
      };
    case FETCH_ASSET_GROUPS:
      return {
        ...state,
        assetGroups: action.payload,
        loading: false,
        loaded: true,
      };
    case FETCH_ASSET_TYPES:
      return {
        ...state,
        assetTypes: action.payload,
        loading: false,
        loaded: true,
      };
    case FETCH_SERVICEAREA_FEATURES:
      return {
        ...state,
        serviceAreaFeatures: action.payload,
        loading: false,
        loaded: true,
      };
    case FETCH_ALL_SERVICEAREA:
      return {
        ...state,
        serviceAreasAll: action.payload,
        loading: false,
        loaded: true,
      };
    case FETCH_WORKFLOW_STATUS:
      return {
        ...state,
        workflow: action.payload,
        loading: false,
        loaded: true,
      };
    case FETCH_ROLES:
      return {
        ...state,
        roles: action.payload,
        loading: false,
        loaded: true,
      };
    case FETCH_ENTERPRISE_USERS:
      return {
        ...state,
        users: action.payload,
        loading: false,
        loaded: true,
      };
    case FETCH_PROJECT_ASSIGNMENTS:
      return {
        ...state,
        assignments: action.payload,
        loading: false,
        loaded: true,
      };
    case FETCH_UNITS_CONFIG:
      return {
        ...state,
        assetLookup: action.payload.groupedResult,
        assetSuffixes: action.payload.result,
        loading: false,
      };
    case FETCH_USERS:
      return {
        ...state,
        users: action.payload,
        loading: false,
      };
    case FETCH_PROJECT_UNITS_CONFIG:
      console.log(
        '$$$PROJ CONFIG 2',
        action.payload.groupedResult,
        'REsult',
        action.payload.result
      );
      return {
        ...state,
        projectAssets: action.payload.groupedResult,
        projectSuffixes: action.payload.result,
        loading: false,
      };
    case CLEAR_PROJECT_UNITS_CONFIG:
      return {
        ...state,
        projectAssets: [],
        projectSuffixes: [],
        loading: false,
      };
    case FETCH_PROJECT_UNITS_RAW:
      return {
        ...state,
        projectRawAssets: action.payload,
        loading: false,
      };
    case FETCH_INTELLI_FIBER_ROLES:
      return {
        ...state,
        intelliFiberRoles: action.payload,
        loading: false,
      };
    case FETCH_INTELLI_FIBER_USER_ROLES:
      return {
        ...state,
        intelliFiberUserRoles: action.payload,
        loading: false,
      };
    case FETCH_PROJECT_USER_ROLES:
      return {
        ...state,
        intelliFiberProjectUserRoles: action.payload,
        loading: false,
      };
    case FETCH_PERMISSIONS:
      return {
        ...state,
        permissions: action.payload,
        loading: false,
      };
    case FETCH_PHASES:
      return {
        ...state,
        phases: action.payload,
        loading: false,
      };
    case FETCH_ROLE_PERMISSIONS:
      return {
        ...state,
        rolePermissions: action.payload,
        loading: false,
      };
    case FETCH_PROJECTS_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.payload,
      };
    case SET_PROJECTS:
      console.log('###SETPRJS:', action.payload);
      return {
        ...state,
        projects: action.payload,
      };
    case SELECT_PROJECT:
      return {
        ...state,
        selectedProject: action.payload,
        assignments: [],
      };
    case UPDATE_PROJECT:
      var i = state.projects.findIndex((o) => o.ID === action.payload.ID);
      if (state.projects[i]) {
        state.projects[i] = action.payload;
      } else {
        state.projects.push(action.payload);
      }
      return {
        ...state,
        loading: false,
        loaded: true,
      };
    case 'SET_CLIENT_USER_LIST':
      return { ...state, clientUserList: action.payload };
    case 'SET_CLIENT_GROUP':
      return { ...state, clientGroup: action.payload };
    case SET_FLAGS:
      return {
        ...state,
        ...action.payload,
      };
    case SET_AFTER_RELOAD:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
